import * as React from "react";

function SvgVwo(props, ref) {
  return (
    <svg
      viewBox="0 0 279 96"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M229.76 0C256.95 0 279 21.49 279 48s-22.04 48-49.24 48c-22.903 0-42.15-15.245-47.656-35.895l4.365 2.763 2.264-3.398c5.108 17.397 21.543 30.13 41.03 30.13 23.566 0 42.671-18.625 42.671-41.6s-19.1-41.6-42.671-41.6c-2.02 0-4 .136-5.944.4l4.126-6.195-.847-.536A51.17 51.17 0 01229.762 0"
          fill="#BF3078"
        />
        <path
          d="M180.53 0h49.24l-65.65 96-24.618-36-24.618 36-24.895-36.406 3.893-5.845 21 30.713 19.16-28.01 5.462-7.988 5.462 7.988 19.16 28.01 53.38-78.06H125.427l4.263-6.4h50.845"
          fill="#802050"
        />
        <path
          d="M65.65 96L0 0h131.29L65.64 96m0-11.538l53.38-78.06H12.26l53.38 78.06"
          fill="#26134D"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgVwo);
